import React, { Component } from 'react';

import "./Promo.scss"
import data from "../../api/data.json"

class Promo extends Component {
  render() {
    window.addEventListener("scroll", function () {
      if (window.scrollY >= 576) {
        window.document.querySelector("body").classList.add("scrolled");
      } else {
        window.document.querySelector("body").classList.remove("scrolled");
      }
    });
    return (
      <section className="section section-promo">
        <div className="padding">
          <div className="central">
            <div className="logo"></div>
            <div className="headline">
              <h3 dangerouslySetInnerHTML={{ __html: data.welcome.headline }}></h3>
            </div>
            <div className="button">
              <div className="label">
                {data.welcome.button}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Promo;



// WEBPACK FOOTER //
// ./src/components/Promo/Promo.js